
import React from "react";
import {Modal2} from "../modal";

const dump_text = lines => {
  return lines.map((line, index) => {
    return (<div key={index}>{line}</div>);
  })
}

const HypervergeDialog = props => {

  const button_list = [
    { id: "ok", label: "Ok", cb: props.on_click },
  ];

  const container_style = {
    width: "30rem",
    fontSize: "1.5rem",
  }

  return (
    <Modal2
      buttonList={button_list}
      container_style={container_style}>
      <div align={"center"}>
        { dump_text(props.lines) }
      </div>
    </Modal2>
  );
}

export { HypervergeDialog };
